import { useNavigate } from "react-router-dom";
import { usePendingKPIs, useCompanies } from "@/hooks/useCompanyData";
import { AlertTriangle, Send } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PendingBanner() {
  const navigate = useNavigate();
  const { data: companies } = useCompanies();
  const firstCompany = companies?.[0];
  const { data: pending } = usePendingKPIs(firstCompany?.id);

  if (!pending || pending.pending === 0 || !firstCompany) return null;

  return (
    <div className="bg-warning/10 border border-warning/20 rounded-2xl p-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <AlertTriangle className="h-5 w-5 text-warning flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium truncate">
            {pending.pending} KPI{pending.pending !== 1 ? "s" : ""} still pending this week
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {pending.names.slice(0, 2).join(", ")}
            {pending.names.length > 2 && ` +${pending.names.length - 2} more`}
          </p>
        </div>
      </div>
      <Button
        size="sm"
        className="rounded-xl flex-shrink-0 bg-gradient-accent"
        onClick={() => navigate(`/app/companies/${firstCompany.id}/submit`)}
      >
        <Send className="h-4 w-4 mr-1.5" />
        Submit now
      </Button>
    </div>
  );
}
